import React from "react";
import { usePageReference } from "modules/unions/usePageReference";
import { hasStartAndEndTag, htmlSafe } from "modules/utils";
import { DegreesBannerMediumProps } from ".";

const SixtyThreeDegreesBannerMediumSkeleton = ({ copy, cta, show_myaxelos_header }: DegreesBannerMediumProps) => {
  let href = cta?.page_link ? usePageReference(cta?.page_link[0]) : cta?.custom_url;
  return (
    <div style={{ visibility: "hidden" }}>
      {show_myaxelos_header && (
        <header>
          <div>
            <h2>The best practice community that's all about you</h2>
          </div>
        </header>
      )}
      <div>
        <div>
          <div>
            <div>
              <div>{hasStartAndEndTag(copy) ? htmlSafe(copy) : <p>{htmlSafe(copy)}</p>}</div>
            </div>
            {href && <a href={href}>{cta.label}</a>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SixtyThreeDegreesBannerMediumSkeleton);
